import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, getNoCatch, postNoCatch } from '@api/request';
import { mmplAPI } from '@api/modules/mmpl';
import { imgeAPI } from '@api/modules/imge';
import editHeader from '@/views/component/editHeader';
import inputUser from '@/views/component/inputUser';
import helper from '@assets/js/helper';
import MmplPartList from '@/views/MouldManagement/MmplManage/TabChild/Componet/TabPanel/MmplPartList.vue';
import imgPopover from '@/views/component/imgPopover';
import MmplMtrlImport from '@/views/MouldManagement/MmplManage/TabChild/Componet/MmplMtrlImport.vue';
import { cloneDeep } from 'lodash';
import { muopAPI } from '@api/modules/muop';
import { dateToTimeStamp } from '@assets/js/dateUtils';
import DynamicForm from '@/components/DynamicForm.vue';
import { mupcAPI } from '@api/modules/mupc';
export default {
  name: 'mmplEditMain',
  components: {
    editHeader: editHeader,
    inputUser: inputUser,
    imgPopover: imgPopover,
    MmplPartList: MmplPartList,
    MmplMtrlImport: MmplMtrlImport,
    DynamicForm: DynamicForm
  },
  data: function data() {
    return {
      costFormShow: false,
      elapsedTimeFromShow: false,
      split: 8,
      remarkForm: [{
        label: '备注',
        prop: 'proceRemark',
        itemType: 'input',
        model: '',
        index: 0,
        rows: 5,
        type: 'textarea',
        disabled: true
      }],
      timeForm: [{
        label: '开始时间',
        prop: 'startTime',
        itemType: 'date',
        model: null,
        index: 0,
        disabled: true
      }, {
        label: '结束时间',
        prop: 'endTime',
        itemType: 'date',
        model: null,
        index: 0,
        disabled: true
      }],
      defaultFrom: [{
        label: '选择模板',
        prop: 'proceTemplate',
        itemType: 'select',
        options: [{
          label: '板片A',
          value: '1'
        }],
        model: '1',
        index: 0,
        disabled: true
      }],
      costForm: [{
        label: '委外费用',
        prop: 'proceMoney',
        itemType: 'input',
        model: '',
        index: 0,
        inputAppend: '元',
        disabled: true
      }],
      machineFrom: [{
        label: '选择机器',
        prop: 'proceMachine',
        itemType: 'select',
        options: [{
          label: '板片A',
          value: '1'
        }],
        model: '1',
        index: 0,
        disabled: true
      }],
      placeTimeFrom: [{
        label: '到位时间',
        prop: 'placeTime',
        itemType: 'date',
        model: null,
        index: 0,
        disabled: true
      }],
      elapsedTimeFrom: [{
        label: '总耗时',
        prop: 'sumTime',
        itemType: 'date',
        model: null,
        index: 0,
        formatTime: 'HH:mm:ss',
        disabled: true
      }],
      formList: [],
      mmplForm: {
        mmpl_mdrl_list: []
      },
      activeName: 'BOM清单',
      isShow: true,
      btn: {},
      stffType: [],
      stffForm: {
        stff_name: '',
        cptt_name: '',
        dept_name: '',
        dept_team_name: '',
        stff_id: Number,
        cptt_id: Number,
        dept_id: Number,
        dept_team_id: Number
      },
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400
      },
      uploadUrl: helper.modePrepend(imgeAPI.uploadImage),
      show: false,
      imgForm: {
        imge_id: null,
        imge_url: null,
        imge_urlO: null
      },
      loadingFlag: true,
      settNum: '',
      mmplListDisable: true,
      partSelectChoose: [],
      partCopy: [],
      mouldProdList: [{
        id: 0,
        label: '模房'
      }, {
        id: 1,
        label: '工厂'
      }],
      mdrlFlag: false,
      processName: '设计',
      processNameList: [],
      processBackup: [],
      mdrlListBackup: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.initData();
  },
  watch: {},
  methods: {
    initData: function initData() {
      this.loadingFlag = false;
      this.getMmplInfo();
    },

    /**
     * 启用编辑
     */
    openEdit: function openEdit() {
      this.isShow = false;
      this.showBom = false;
      this.$emit('isShow', this.isShow);
    },

    /**
     * 撤销编辑
     */
    closeEdit: function closeEdit() {
      var _this = this;

      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this.isShow = true;
        _this.showBom = true;

        _this.$emit('isShow', _this.isShow);

        _this.show = true;

        _this.$message({
          type: 'info',
          message: '已撤销编辑!'
        });

        _this.initData();
      });
    },
    seChange: function seChange() {
      var _this2 = this;

      switch (this.processName) {
        case '设计':
          this.split = 8;
          this.formList = cloneDeep(this.defaultFrom.concat(this.timeForm));
          this.costFormShow = false;
          this.elapsedTimeFromShow = true;
          break;

        case '编程':
          this.split = 8;
          this.formList = cloneDeep(this.defaultFrom.concat(this.timeForm));
          this.costFormShow = false;
          this.elapsedTimeFromShow = true;
          break;

        case '钢材到位':
          this.split = 12;
          this.formList = cloneDeep(this.defaultFrom.concat(this.placeTimeFrom));
          this.elapsedTimeFromShow = false;
          this.costFormShow = false;
          break;

        case '模架到位':
          this.split = 12;
          this.formList = cloneDeep(this.defaultFrom.concat(this.placeTimeFrom));
          this.elapsedTimeFromShow = false;
          this.costFormShow = false;
          break;

        case 'CNC':
          this.split = 6;
          this.formList = cloneDeep(this.defaultFrom.concat(this.machineFrom).concat(this.timeForm));
          this.costFormShow = true;
          this.elapsedTimeFromShow = false;
          break;

        case 'EDM':
          this.split = 6;
          this.formList = cloneDeep(this.defaultFrom.concat(this.machineFrom).concat(this.timeForm));
          this.costFormShow = true;
          this.elapsedTimeFromShow = false;
          break;

        case '线切割':
          this.split = 12;
          this.formList = cloneDeep(this.timeForm);
          this.costFormShow = true;
          this.elapsedTimeFromShow = true;
          break;

        case '车床':
          this.split = 12;
          this.formList = cloneDeep(this.timeForm);
          this.costFormShow = true;
          this.elapsedTimeFromShow = true;
          break;

        case '省模':
          this.split = 12;
          this.formList = cloneDeep(this.timeForm);
          this.costFormShow = true;
          this.elapsedTimeFromShow = true;
          break;

        case '装配':
          this.split = 12;
          this.formList = cloneDeep(this.timeForm);
          this.costFormShow = true;
          this.elapsedTimeFromShow = true;
          break;

        case '表面处理':
          this.formList = cloneDeep(this.timeForm);
          this.costFormShow = true;
          this.elapsedTimeFromShow = true;
          break;

        case '检验完成':
          this.split = 24;
          this.costFormShow = false;
          this.elapsedTimeFromShow = false;
          break;

        case '模具完成':
          this.split = 24;
          this.costFormShow = false;
          this.elapsedTimeFromShow = false;
          break;
      }

      get(mupcAPI.readMurfCard, {
        murf_proc_name: this.processName,
        murf_no: this.mmplForm.murf_no
      }).then(function (res) {
        if (res.data.code === 0) {
          var _res$data$data$sumTim, _res$data$data, _res$data$data$proceM, _res$data$data2;

          _this2.processNameList = res.data.data.murf.proc_order.split(',');
          var formList = cloneDeep(_this2.formList);
          var map = formList.map(function (_ref) {
            var prop = _ref.prop;
            return prop;
          });
          var handledArr = [];
          res.data.data.proc.forEach(function (item, index) {
            var deepForm = cloneDeep(formList);
            map.forEach(function (subItem, subIndex) {
              deepForm[subIndex].model = item[subItem];
              deepForm[subIndex].index = index;
              deepForm[subIndex].proceId = item.proceId;
            });
            handledArr = handledArr.concat(deepForm);
          });
          _this2.formList = handledArr;
          if (_this2.elapsedTimeFromShow) _this2.elapsedTimeFrom[0].model = (_res$data$data$sumTim = (_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.sumTime) !== null && _res$data$data$sumTim !== void 0 ? _res$data$data$sumTim : 0;
          if (_this2.costFormShow) _this2.costForm[0].model = (_res$data$data$proceM = (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.proceMoney) !== null && _res$data$data$proceM !== void 0 ? _res$data$data$proceM : 0;
        }
      });
    },

    /*
    //生成采购报价单
    generatePrice() {
    	if (this.mmplForm.quta_id === 0) {
    		if (!this.mmplForm.imge_id) {
    			return this.$message.warning("请上传图片");
    		}
    		// if(!this.mmplForm.mmpl_box_l || Number(this.mmplForm.mmpl_box_l)===0){
    		//   return this.$message.warning("请填写纸箱长度且纸箱长度不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_box_w || Number(this.mmplForm.mmpl_box_w)===0){
    		//   return this.$message.warning("请填写纸箱宽度且纸箱宽度不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_box_h || Number(this.mmplForm.mmpl_box_h)===0){
    		//   return this.$message.warning("请填写纸箱高度且纸箱高度不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_bag_l || Number(this.mmplForm.mmpl_bag_l)===0){
    		//   return this.$message.warning("请填写塑料袋长度且塑料袋长度不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_bag_w || Number(this.mmplForm.mmpl_bag_w)===0){
    		//   return this.$message.warning("请填写塑料袋宽度且塑料袋宽度不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_qpc || Number(this.mmplForm.mmpl_qpc)===0){
    		//   return this.$message.warning("请填写装箱数且装箱数不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_qpb || Number(this.mmplForm.mmpl_qpb)===0){
    		//   return this.$message.warning("请填写装袋数且装袋数不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_moq || Number(this.mmplForm.mmpl_moq)===0){
    		//   return this.$message.warning("请填写最小起订量且最小起订量不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_skin_weight || Number(this.mmplForm.mmpl_skin_weight)===0){
    		//   return this.$message.warning("请填写皮壳重量且皮壳重量不可为0");
    		// }
    		// if(!this.mmplForm.mmpl_fill_weight || Number(this.mmplForm.mmpl_fill_weight)===0){
    		//   return this.$message.warning("请填写填充物重量且填充物重量不可为0");
    		// }
    		let params = {}
    		let userInfo = this.$cookies.get("userInfo");
    		params.mmpl_id = this.mmplForm.mmpl_id;
    		params.user_id = userInfo.user_id;
    		params.stff_id = userInfo.stff_id;
    		params.dept_id = userInfo.dept_id;
    		params.dept_team_id = userInfo.dept_team_id;
    		params.stff_name = userInfo.stff_name;
    		post(qutaAPI.addQuta, params)
    				.then(res => {
    					if (res.data.code === 0) {
    						this.$message({
    							type: "success",
    							message: "生成成功",
    						});
    						this.initData()
    						this.jump('/quta_edit', {
    									perm_id: 123,
    									form_id: res.data.data.form_id
    								}
    						)
    					}
    				})
    	} else {
    		this.jump('/quta_edit', {
    					perm_id: 123,
    					form_id: this.mmplForm.quta_id
    				}
    		)
    	}
    },*/

    /**
     * 提交表单
     */
    submit: function submit(formName) {
      var _this3 = this;

      var constr;

      if (this.$route.query.rework === 'true') {
        constr = '是否确认保存？保存之后单据将重新变为草拟状态';
      } else {
        constr = '确认提交?';
      }

      this.$confirm(constr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$refs[formName].validate(function (valid) {
          if (valid) {
            _this3.saveInfo();
          } else {
            console.log('error submit!');
            return false;
          }
        });
      });
    },

    /**
     * 保存
     */
    saveInfo: function saveInfo() {
      var _this4 = this;

      this.mdrlListBackup = this.mdrlListBackup.filter(function (fitem) {
        return _this4.mmplForm.mmpl_mdrl_list.every(function (eitem) {
          return eitem.mdtk_id !== fitem.mdtk_id;
        });
      });
      this.mdrlListBackup.forEach(function (item) {
        return item.destroy_flag = 1;
      });
      this.mmplForm.mmpl_mdrl_list = this.mmplForm.mmpl_mdrl_list.concat(this.mdrlListBackup);
      postNoCatch(mmplAPI.editMmpl, this.mmplForm).then(function (_ref2) {
        var data = _ref2.data;

        _this4.$message({
          type: 'success',
          message: '保存成功'
        });

        _this4.isShow = true;

        _this4.initData();
      });
    },

    /**
     * 刷新按钮
     */
    buttonRefresh: function buttonRefresh() {
      this.initData();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      if (res.code === 0) {
        var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        var urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.mmplForm.imge_id = res.data.imge_id;
        this.mmplForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
        this.mmplForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      }
    },

    /**
     * 上传头像前
     */
    beforeAvatarUpload: function beforeAvatarUpload() {},

    /**
     * 打开导入BOM清单弹窗
     */
    importMmplMdrl: function importMmplMdrl() {
      this.mdrlFlag = true;
    },

    /**
     * 表单重置
     */
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /**
     * 获取表单信息
     */
    getMmplInfo: function getMmplInfo() {
      var _this5 = this;

      getNoCatch(mmplAPI.getMmplById, {
        mmpl_id: this.$route.query.form_id
      }).then(function (_ref3) {
        var data = _ref3.data;

        for (var dataKey in data.form) {
          if (data.form[dataKey] === 0) {
            data.form[dataKey] = null;
          }
        }

        _this5.mmplForm = data.form;

        _this5.seChange(); // this.processBackup = cloneDeep(data.form.murf_proc_list);
        // this.mdrlListBackup = cloneDeep(data.form.mmpl_mdrl_list);


        _this5.btn = data.btn;

        _this5.getInputUser();
      });
    },

    /**
     * 获取录入人
     */
    getInputUser: function getInputUser() {
      this.stffForm.cptt_id = this.mmplForm.cptt_id;
      this.stffForm.user_id = this.mmplForm.user_id;
      this.stffForm.dept_id = this.mmplForm.dept_id;
      this.stffForm.stff_id = this.mmplForm.stff_id;
      this.stffForm.dept_name = this.mmplForm.dept_name;
      this.stffForm.dept_team_id = this.mmplForm.dept_team_id;
      this.stffForm.dept_team_name = this.mmplForm.dept_team_name;
      this.stffForm.stff_name = this.mmplForm.stff_name;
    },

    /**
     * 材料导入确认
     * @param val 弹窗选中的对象
     */
    mdrlConfirm: function mdrlConfirm(val) {
      this.mdrlFlag = false;
      this.mmplForm.mmpl_mdrl_list = this.mmplForm.mmpl_mdrl_list.concat(val);
      this.mmplForm.mmpl_mdrl_list.sort(function (x, y) {
        return x.mdrl_type - y.mdrl_type;
      });
    },

    /**
     * 保存工序信息
     * @param index 工序下标
     */
    saveChildInfo: function saveChildInfo(index) {
      var _this6 = this;

      this.$refs["childForm".concat(index)][0].validate(function (valid) {
        if (valid) {
          var tempForm = cloneDeep(_this6.mmplForm.murf_proc_list[index]);
          tempForm.rewk_time = dateToTimeStamp(tempForm.rewk_time);
          tempForm.getm_time = dateToTimeStamp(tempForm.getm_time);
          tempForm.oper_time = dateToTimeStamp(tempForm.oper_time);

          var _this6$$cookies$get = _this6.$cookies.get('userInfo'),
              user_id = _this6$$cookies$get.user_id,
              stff_id = _this6$$cookies$get.stff_id,
              stff_name = _this6$$cookies$get.stff_name;

          tempForm.user_id = user_id;
          tempForm.stff_id = stff_id;
          tempForm.stff_name = stff_name;
          postNoCatch(muopAPI.editMurfProc, tempForm).then(function (_ref4) {
            var data = _ref4.data,
                code = _ref4.code,
                msg = _ref4.msg;

            if (code !== 0) {
              _this6.saveChildCancel(index);

              return _this6.$message.success(msg);
            }

            _this6.mmplForm.murf_proc_list[index].childFormShow = true;

            _this6.$message.success('提交成功!');
          });
        } else {
          return false;
        }
      });
    },

    /**
     * 保存取消 恢复元数据 刷新视图
     * @param {string|number} index 工序下标
     */
    saveChildCancel: function saveChildCancel(index) {
      this.$set(this.mmplForm.murf_proc_list[index], 'oper_time', this.processBackup[index].oper_time);
      this.$set(this.mmplForm.murf_proc_list[index], 'rewk_time', this.processBackup[index].rewk_time);
      this.$set(this.mmplForm.murf_proc_list[index], 'getm_time', this.processBackup[index].getm_time);
      this.$set(this.mmplForm.murf_proc_list[index], 'murf_proc_remark', this.processBackup[index].murf_proc_remark);
      this.$set(this.mmplForm.murf_proc_list[index], 'childFormShow', this.processBackup[index].childFormShow);
    },

    /**
     * 配件删除
     */
    delPartList: function delPartList() {
      var _this7 = this;

      if (this.partSelectChoose.length === 0) return this.$message.warning('至少选择一条数据');
      this.partSelectChoose.forEach(function (item) {
        var index = _this7.mmplForm.mmpl_mdrl_list.findIndex(function (x) {
          return x.mmpl_mdrl_id === item.mmpl_mdrl_id;
        });

        _this7.mmplForm.mmpl_mdrl_list.splice(index, 1);
      });
      this.$refs.bomTable.clearSelection();
    },

    /**
     * BOM清单勾选框
     */
    handleSelectionPart: function handleSelectionPart(val) {
      this.partSelectChoose = val;
    }
  }
};